import React from 'react'
import Input from 'Components/Input'
import Grid from '@material-ui/core/Grid'
import ApiRequest from 'EurestoApi/ApiRequest'
import EurestoForm from 'Components/Form'
import Utils from 'EurestoFonction/Utils'


const project = require('EurestoConfig/project.config')

export default class extends React.Component {
  constructor(props) {
    super(props)
    const newState = {
      ...props,
      action: props.action,
      key: Utils.getRandomNumber(),
      generate: props.action === 'add'
    }
    this.state = {
      saveState: { ...EurestoClone(newState) },
      ...newState
    }
  }

  componentDidMount() {
    if (this.state.action === 'update' || this.state.action === 'duplicate' || this.state.action === 'view') {
      this.getProduit()
    }
  }

  getProduit = async () => {
    const result = await ApiRequest(project.api + 'restaurant', {
      requete: 'table',
      action: 'get',
      id: this.state.id
    }, { showAlertError: false })
    if (result && result.code === 1) {
      const newState = {
        defaultLibelle: result.results.libelle,
        libelle: result.results.libelle,
        categorie_id: result.results.categorie_id,
        couverts_max: result.results.couverts_max,
        couverts_min: result.results.couverts_min,
        key: Utils.getRandomNumber()
      }
      this.setState({
        saveState: { action: 'view', ...EurestoClone(this.state.saveState), ...EurestoClone(newState) },
        ...newState,
        key: Utils.getRandomNumber()
      }, this.forceUpdate)
    }
  }

  onChangeState = (e, name) => {
    this.setState({
      [name]: e
    }, this.forceUpdate)
  }

  onCancel = () => {
    this.setState({
      libelle: undefined,
      couverts_max: undefined,
      couverts_min: undefined,
      nb_table: undefined,
      prefixe: undefined,
      suffixe: undefined,
      index_start: undefined,
      key: Utils.getRandomNumber(),
      action: 'add',
      generate: false,
    }, () => this.props.onCancel())
  }

  onSave = async (action) => {
    let result
    if (this.state.generate) {
      await Promise.all(Utils.generateArray(this.state.nb_table).map(async (_, i) => {
        await ApiRequest(project.api + 'restaurant', {
          requete: 'table',
          action: 'add',
          libelle: (this.state.prefixe || '') + ((parseInt(this.state.index_start + '') || 1) + i) + (this.state.suffixe || ''),
          categorie_id: this.state.categorie_id,
          couverts_max: this.state.couverts_max,
          couverts_min: this.state.couverts_min,
        }, {
          showAlertError: (i + 1) === this.state.nb_table
        })
      }))
    } else {
      const result = await ApiRequest(project.api + 'restaurant', {
        requete: 'table',
        action: action === 'update' ? 'update' : 'add',
        id: this.state.id,
        libelle: this.state.libelle,
        categorie_id: this.state.categorie_id,
        couverts_max: this.state.couverts_max,
        couverts_min: this.state.couverts_min,
      })
      if (!result || result.code !== 1) {
        return
      }
    }
    this.onCancel()
  }

  onDelete = async () => {
    const r = await ApiRequest(project.api + 'restaurant', {
      requete: 'table',
      action: 'delete',
      id: this.state.id,
    })
    if (r && r.code === 1) {
      this.setState({
        action: this.props.isAllow && (this.props.isAllow.add && 'add' || ' ')
      })
    }
  }

  onArchive = async () => {
    console.log('not done yet')
  }

  onView = (action) => {
    const newState = this.state.saveState
    newState.saveState = { ...EurestoClone(this.state.saveState) }
    newState.key = Utils.getRandomNumber()
    const keys = Object.keys(this.state)
    const stateReset = keys.reduce((acc, v) => ({ ...acc, [v]: undefined }), {})
    this.setState({
      ...stateReset,
      ...newState
    }, action === 'add' && this.props.onCancel(false) || this.forceUpdate)
  }

  form = (disabled, autoFocus) => {
    return (
      <Grid key={this.state.key} container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
        justify="flex-start"
        alignItems="stretch">
        {this.state.generate &&
          <React.Fragment>
            <Input
              title={EurestoI18n.t('commun:Nombre de tables à générer')}
              disabled={disabled}
              autoFocus={autoFocus}
              onChange={this.onChangeState}
              name={'nb_table'}
              value={this.state.nb_table !== undefined ? this.state.nb_table : ''}
              type={'text'}
            />
            <Input
              title={EurestoI18n.t('commun:Prefixe')}
              disabled={disabled}
              onChange={this.onChangeState}
              name={'prefixe'}
              value={this.state.prefixe !== undefined ? this.state.prefixe : ''}
              type={'text'}
            />
            <Input
              title={EurestoI18n.t('commun:Suffixe')}
              disabled={disabled}
              onChange={this.onChangeState}
              name={'suffixe'}
              value={this.state.suffixe !== undefined ? this.state.suffixe : ''}
              type={'text'}
            />
            <Input
              title={EurestoI18n.t('commun:Index de début')}
              disabled={disabled}
              onChange={this.onChangeState}
              name={'index_start'}
              value={this.state.index_start !== undefined ? this.state.index_start : ''}
              type={'text'}
            />
          </React.Fragment> ||

          <Input
            title={EurestoI18n.t('commun:Numéro de table')}
            disabled={disabled}
            autoFocus={autoFocus}
            onChange={this.onChangeState}
            name={'libelle'}
            value={this.state.libelle !== undefined ? this.state.libelle : ''}
            type={'text'}
          />
        }

        <Input
          title={EurestoI18n.t('commun:Nombre de couverts maximum')}
          disabled={disabled}
          onChange={this.onChangeState}
          name={'couverts_max'}
          min={1}
          value={this.state.couverts_max !== undefined ? this.state.couverts_max : ''}
          type={'number'}
        />
        {this.state.couverts_max && <Input
          title={EurestoI18n.t('commun:Nombre de couverts minimum acceptable')}
          disabled={disabled}
          onChange={this.onChangeState}
          name={'couverts_min'}
          min={1}
          max={this.state.couverts_max !== undefined ? this.state.couverts_max : ''}
          value={this.state.couverts_min !== undefined ? this.state.couverts_min : ''}
          type={'number'}
        />}
      </Grid>
    )
  }

  generateTable = _ => {
    this.setState({
      key: Utils.getRandomNumber(),
      action: 'add',
      generate: true
    })
  }

  render() {
    return (
      <EurestoForm key={this.state.key}
        {...this.props.formProps}
        libelle={this.state.defaultLibelle}
        action={this.state.action}
        isAllow={{
          ...this.props.isAllow,
          archive: false
        }}
        onSave={this.onSave}
        onCancel={this.onCancel}
        onDelete={this.onDelete}
        onArchive={this.onArchive}
        onView={this.onView}
        libelleAdd={this.state.generate && EurestoI18n.t('commun:Nouvelles tables') || EurestoI18n.t('commun:Nouvelle table')}
        children={this.form} />
    )
  }
}


/*buttons={[
  {
    isAllow: this.state.action === 'view',
    title: 'Générer',
    className: 'EurestoSecondary--text',
    icon: ' ei-commun_modifier',
    cb: this.generateTable
  }
]}*/



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataForm/Template/Reservation/Table.js